export const QUIZ_QUESTIONS = [
  {
    id: 1,
    question: "What type of auto insurance do you currently have?",
    options: [
      { id: 'A', text: "Liability Only (state minimum)" },
      { id: 'B', text: "Full Coverage (comprehensive + collision)" },
      { id: 'C', text: "I'm not sure what I have" }
    ]
  },
  {
    id: 2,
    question: "When does your auto insurance policy renew?",
    options: [
      { id: 'A', text: "This month (0-30 days)" },
      { id: 'B', text: "1-3 months from now" },
      { id: 'C', text: "3-6 months from now" },
      { id: 'D', text: "6+ months away" },
      { id: 'E', text: "I don't know" }
    ]
  },
  {
    id: 3,
    question: "What matters most to you about your auto insurance?",
    options: [
      { id: 'A', text: "Lowest possible price" },
      { id: 'B', text: "Best coverage and protection" },
      { id: 'C', text: "A balance of both" },
      { id: 'D', text: "I'm not sure" }
    ]
  },
  {
    id: 4,
    question: "When was the last time you reviewed your auto insurance coverage?",
    options: [
      { id: 'A', text: "Within the past year" },
      { id: 'B', text: "1-2 years ago" },
      { id: 'C', text: "3+ years ago" },
      { id: 'D', text: "I've never reviewed it" },
      { id: 'E', text: "I can't remember" }
    ]
  },
  {
    id: 5,
    question: "What's your biggest concern about your current auto insurance?",
    options: [
      { id: 'A', text: "I'm paying too much" },
      { id: 'B', text: "I don't have enough coverage" },
      { id: 'C', text: "I don't understand my policy" },
      { id: 'D', text: "I'm worried about gaps in protection" },
      { id: 'E', text: "Everything seems fine" }
    ]
  }
];

export const RESULT_TYPES = {
  UNDERINSURED: 'underinsured',
  OVERPAYING: 'overpaying',
  GAPS: 'gaps'
};

export const calculateResult = (answers) => {
  // Check Result 2: Overpaying (Strict ALL conditions)
  const isOverpaying = 
    answers[1] === 'B' && 
    answers[3] === 'A' && 
    ['C', 'D'].includes(answers[4]) && 
    answers[5] === 'A';

  if (isOverpaying) return RESULT_TYPES.OVERPAYING;

  // Check Result 1: Underinsured (ANY of these conditions)
  const isUnderinsured = 
    answers[1] === 'A' || 
    answers[2] === 'E' || 
    ['C', 'D', 'E'].includes(answers[4]) || 
    ['B', 'D'].includes(answers[5]);

  if (isUnderinsured) return RESULT_TYPES.UNDERINSURED;

  // Default Result 3: Coverage Gaps
  return RESULT_TYPES.GAPS;
};